import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import BottomNav from '../BottomNav';
import theme from '../theme';

function BadgeVerificato({ size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: 3, flexShrink: 0 }}>
      <path d="M8 1L2 3.5V8c0 3.3 2.5 5.8 6 7 3.5-1.2 6-3.7 6-7V3.5L8 1z" fill={theme.colors.primary}/>
      <path d="M5.5 8l2 2 3-3" stroke={theme.colors.white} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function UserSearch() {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleSearch = async (value) => {
    setQuery(value);
    if (value.trim().length < 2) {
      setResults([]);
      setSearched(false);
      return;
    }
    setLoading(true);
    const { data } = await supabase
      .from('profiles')
      .select('id, full_name, avatar_url, city, identity_status')
      .ilike('full_name', `%${value.trim()}%`)
      .limit(20);
    setResults(data || []);
    setSearched(true);
    setLoading(false);
  };

  const initials = (name) => name
    ? name.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase()
    : '?';

  return (
    <div style={{ maxWidth: theme.layout.maxWidth, margin: '0 auto', fontFamily: theme.font.family, minHeight: '100vh', background: theme.colors.background }}>

      {/* Header */}
      <div style={{ background: theme.colors.primary, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: theme.spacing.md }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', color: theme.colors.white, fontSize: 22, cursor: 'pointer', padding: 0 }}>
          ←
        </button>
        <div style={{ flex: 1, position: 'relative' }}>
          <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', fontSize: theme.font.size.lg, color: 'rgba(255,255,255,0.7)' }}>🔍</span>
          <input
            autoFocus
            value={query}
            onChange={e => handleSearch(e.target.value)}
            placeholder="Cerca un utente..."
            style={{
              width: '100%', padding: '10px 36px 10px 34px',
              borderRadius: theme.radius.md, border: 'none', fontSize: theme.font.size.md,
              boxSizing: 'border-box', background: 'rgba(255,255,255,0.2)',
              color: theme.colors.white, outline: 'none'
            }}
          />
          {query && (
            <span
              onClick={() => { setQuery(''); setResults([]); setSearched(false); }}
              style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: theme.colors.white, fontSize: theme.font.size.xl }}>
              ✕
            </span>
          )}
        </div>
      </div>

      {/* Risultati */}
      <div style={{ padding: '12px 16px', paddingBottom: 80 }}>

        {loading && (
          <p style={{ textAlign: 'center', color: theme.colors.textMuted, marginTop: 24 }}>Ricerca in corso...</p>
        )}

        {!loading && searched && results.length === 0 && (
          <p style={{ textAlign: 'center', color: theme.colors.textMuted, marginTop: 40 }}>
            Nessun utente trovato per "<strong>{query}</strong>"
          </p>
        )}

        {!loading && !searched && (
          <p style={{ textAlign: 'center', color: '#bbb', marginTop: 40, fontSize: theme.font.size.md }}>
            Digita almeno 2 caratteri per cercare
          </p>
        )}

        {results.map(user => (
          <div
            key={user.id}
            onClick={() => navigate(`/utente/${user.id}`)}
            style={{
              display: 'flex', alignItems: 'center', gap: theme.spacing.md,
              background: theme.colors.white, borderRadius: theme.radius.lg, padding: '12px 14px',
              marginBottom: 10, cursor: 'pointer',
              border: '1px solid #e8e8e8',
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}>

            <div style={{
              width: 46, height: 46, borderRadius: theme.radius.circle, flexShrink: 0,
              background: theme.colors.primaryLight, overflow: 'hidden',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: theme.font.size.lg, fontWeight: 600, color: theme.colors.primary
            }}>
              {user.avatar_url
                ? <img src={user.avatar_url} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                : initials(user.full_name)
              }
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <span style={{ fontWeight: 600, fontSize: theme.font.size.lg, color: '#222' }}>{user.full_name}</span>
                {user.identity_status === 'verificato' && <BadgeVerificato size={13} />}
              </div>
              {user.city && (
                <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textMuted, marginTop: 2 }}>📍 {user.city}</div>
              )}
            </div>

            <span style={{ color: '#ccc', fontSize: theme.font.size.xl }}>›</span>
          </div>
        ))}
      </div>

      <BottomNav />
    </div>
  );
}

export default UserSearch;